import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import DocPage from "../components/DocPage.vue";
import { company } from "../company";

export default /*#__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DocPage, {
    title: _ctx.$t('pages.contact.title'),
    lede: _ctx.$t('pages.contact.lede')
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.contact.write.title")), 1),
      _createElementVNode("p", null, [
        _createElementVNode("a", {
          href: `mailto:${_unref(company).email}`
        }, _toDisplayString(_unref(company).email), 9, _hoisted_1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.contact.write.p1")), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.contact.demo.title")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.contact.demo.p1")), 1),
      _createElementVNode("p", null, [
        _createElementVNode("a", {
          href: `mailto:${_unref(company).email}?subject=Connectera%20demo`
        }, _toDisplayString(_ctx.$t("pages.contact.demo.link")), 9, _hoisted_2)
      ]),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.contact.where.title")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("pages.contact.where.p1")), 1)
    ]),
    _: 1
  }, 8, ["title", "lede"]))
}
}

})